import { Component, Prop, h } from '@stencil/core';

import { Faq } from '../../../interfaces';
import { DEFAULT_FAQ_DATA, DEFAULT_TITLE, FaqContentType, parseJsonArray } from '../../../utils/utils.landing';

@Component({
  tag: 'landing-faq',
  styleUrl: 'landing-faq.css',
  shadow: true,
})
export class LandingFAQ {
  @Prop() faqTitle: string = '';
  @Prop() faqData: string = '';
  render() {
    const faqDataList: Faq[] = parseJsonArray(this.faqData, DEFAULT_FAQ_DATA);
    const title: string = this.faqTitle == '' ? DEFAULT_TITLE : this.faqTitle;
    const contentClasses = {
      [FaqContentType.Header]: 'mt-4 mb-2 landing-faq-sub-heading-text text-sm font-bold',
      [FaqContentType.Body]: 'mb-2 landing-faq-sub-heading-text text-sm',
      [FaqContentType.Details]: 'mb-2 ml-2 landing-faq-sub-heading-text text-sm list-disc',
      [FaqContentType.DetailsHeader]: 'mb-2 ml-2 landing-faq-sub-heading-text text-sm list-disc font-bold',
      [FaqContentType.DetailsBody]: 'mb-2 ml-2 landing-faq-sub-heading-text text-sm list-none',
    };

    return (
      <div>
        <div class="text-center">
          <h2 class="landing-faq-heading-text text-2xl font-extrabold">{title}</h2>
        </div>
        {faqDataList.map((q) => (
          <div class="my-2.5">
            <ico-accordion class="col-start-3 col-span-8" headerText={q.groupName}>
              {q.answers.map((a) => (
                <div>
                  {[FaqContentType.Header, FaqContentType.Body].includes(a.answerType) && <div innerHTML={a.answer} class={contentClasses[a.answerType]} />}
                  {[FaqContentType.Details, FaqContentType.DetailsHeader, FaqContentType.DetailsBody].includes(a.answerType) && (
                    <ul>
                      <li innerHTML={a.answer} class={contentClasses[a.answerType]} />
                    </ul>
                  )}
                </div>
              ))}
            </ico-accordion>
          </div>
        ))}
      </div>
    );
  }
}
